







































































































































































import { mapGetters } from 'vuex';
import { SearchPayload } from '@/Stores/CitationStore';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import { CitationSearchParams } from './CitationSearchParams';

const plateParam = 'plate';

export default mixins(LocationBasedMixin).extend({
    components: { LocationLookupDropdown },
    computed: {
        ...mapGetters('citationModule', [
            'searchParams'
        ]),
    },
    beforeMount() {
        // Ensure searchParams exist for the current location
        this.$typedStore.modules.citationModule.mutations.setSearchParams({
            location: this.$typedStore.state.currentLocation,
            params: this.searchParams
        });

        const plate = this.$route.query[plateParam] as string | null;
        if (plate) {
            this.clear();
            (this.searchParams as CitationSearchParams).plateNumber = plate;
            this.search();
        }
    },
    methods: {
        clear() {
            const currentLocation = this.$typedStore.state.currentLocation;
            this.$typedStore.modules.citationModule.mutations.clearSearch(currentLocation);
        },
        search() {
            const currentLocation = this.$typedStore.state.currentLocation;
            const searchPayload: SearchPayload = {
                parameters: this.searchParams,
                location: currentLocation
            };
            this.$typedStore.modules.citationModule.actions.beginSearch(searchPayload);
            this.$router.push({
                name: 'citationSearchResults', params: { location: this.location }
            });
        },
    },
});
